import TopNavigation from "@cloudscape-design/components-themed/top-navigation";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import { useAppDispatch } from "../../app/hook";
import { forgetLocation } from "../../features/authentication/location-slice";
import { useGetAuthQuery } from "../../features/api";
import { formatDateTimeWithoutConvert } from "../../utils/format";
import { COMMON_LABELS } from "../default-constants";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // ログインユーザ姓名取得
  const { username, email, lastAuthedAt } = useGetAuthQuery(undefined, {
    selectFromResult: ({ data }) => ({
      username: (data?.familyName ?? "") + " " + (data?.givenName ?? ""),
      email: data?.email ?? "",
      lastAuthedAt: data?.lastAuthedAt
        ? formatDateTimeWithoutConvert(data?.lastAuthedAt)
        : "",
    }),
  });

  return (
    <TopNavigation
      identity={{
        href: "",
        title: "d払い加盟店サイト",
        onFollow: (e) => {
          e.preventDefault();
          navigate("/");
        },
      }}
      utilities={[
        //todo step1 不要
        // {
        //   type: "button",
        //   iconName: "notification",
        //   title: "Notifications",
        //   ariaLabel: "Notifications (unread)",
        //   badge: true,
        //   disableUtilityCollapse: false,
        //   onClick: () => {
        //     navigate("/alerts");
        //   },
        // },
        {
          type: "menu-dropdown",
          text:
            username +
            COMMON_LABELS.LEFT_PARENTHESIS +
            email +
            COMMON_LABELS.RIGHT_PARENTHESIS,
          description: "前回ログイン日時：" + lastAuthedAt,
          iconName: "user-profile",
          items: [
            {
              id: "profile",
              text: "プロファイル",
              href: "/profile",
            },
            { id: "signout", text: "サインアウト" },
          ],
          onItemClick: async (e) => {
            if (e.detail.id === "signout") {
              await Auth.signOut();
              dispatch(forgetLocation());
              navigate("/sign-in");
            }
            if (e.detail.href && e.detail.id === "profile") {
              e.preventDefault();
              navigate(e.detail.href);
            }
          },
        },
      ]}
      i18nStrings={{
        searchIconAriaLabel: "Search",
        searchDismissIconAriaLabel: "Close search",
        overflowMenuTriggerText: "More",
        overflowMenuTitleText: "All",
        overflowMenuBackIconAriaLabel: "Back",
        overflowMenuDismissIconAriaLabel: "Close menu",
      }}
    />
  );
};

export default Header;
